<template>
  <div class="vx-row flex flex-col">
    <div class="vx-col w-full">
      <vs-card>
        <div slot="header">
          <h3>{{media.name}}</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'display-media-edit',params:{id: media.id}})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-edit"
            class="mb-4 self-end"
            size="medium"
          >Edit Media</vs-button>
          <vs-table :data="[1]">
            <template slot="thead">
              <th style="width: 200px;"></th>
              <th style="width: 20px;"></th>
              <th></th>
            </template>
            <tbody>
              <tr>
                <td>Nama Media</td>
                <td>:</td>
                <td>{{media.name}}</td>
              </tr>
              <tr>
                <td>Tipe</td>
                <td>:</td>
                <td>{{media.type }}</td>
              </tr>
              <tr>
                <td>Order</td>
                <td>:</td>
                <td>{{media.order }}</td>
              </tr>
              <tr v-if="media.type == 'video'">
                <td>URL</td>
                <td>:</td>
                <td>{{media.path}}</td>
              </tr>
              <tr v-if="media.type == 'image'">
                <td>Image</td>
                <td>:</td>
                <td>
                  <vs-button
                    @click="openFile(media.path)"
                    color="primary"
                    size="small"
                    class="m-1"
                    type="border"
                    icon-pack="feather"
                    icon="icon-eye"
                  >Lihat</vs-button>
                </td>
              </tr>
              <tr>
                <td>Status</td>
                <td>:</td>
                <td>{{media.status ? 'Aktif' : 'Tidak Aktif'}}</td>
              </tr>
            </tbody>
          </vs-table>
        </div>
      </vs-card>
      <vs-button
        @click="$router.push({name: 'display-media'})"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="mb-4 self-end"
        size="medium"
      >Kembali</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      media: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$http
      .get(`/app/secure/display-mediaplayer/detail/${this.$route.params.id}`)
      .then(r => {
        this.media = r.data.data.media;
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    },
    openFile(path){
      window.open(path);
    }
  }
};
</script>>